import { render, staticRenderFns } from "./store-cover-image.vue?vue&type=template&id=30f5b3fb&scoped=true&"
import script from "./store-cover-image.vue?vue&type=script&lang=js&"
export * from "./store-cover-image.vue?vue&type=script&lang=js&"
import style0 from "./store-cover-image.vue?vue&type=style&index=0&id=30f5b3fb&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f5b3fb",
  null
  
)

export default component.exports